<template>
  <div class="empty">
    <svg
      t="1650608314598"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8006"
      width="200"
      height="200"
    >
      <path
        d="M875.6 724c0 128.5-162.8 160-363.6 160s-363.6-31.5-363.6-160S311.2 418.6 512 418.6 875.6 595.5 875.6 724z"
        fill="#C7F1FF"
        p-id="8007"
      ></path>
      <path
        d="M613 760.5H255.3c-20.8 0-37.6-16.9-37.6-37.6v-466c0-20.8 16.9-37.6 37.6-37.6H613c20.8 0 37.6 16.9 37.6 37.6v466c0.1 20.8-16.8 37.6-37.6 37.6z"
        fill="#FFD500"
        p-id="8008"
      ></path>
      <path
        d="M549.1 360.9H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h235.2c11.8 0 21.4 9.6 21.4 21.4s-9.6 21.4-21.4 21.4zM495.6 467.8H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4s-9.7 21.4-21.5 21.4zM495.6 564.1H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4s-9.7 21.4-21.5 21.4zM495.6 660.3H313.9c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4s-9.7 21.4-21.5 21.4z"
        fill="#FFFFFF"
        p-id="8009"
      ></path>
      <path
        d="M755 844.7H402c-22.1 0-40-17.9-40-40V343.5c0-22.1 17.9-40 40-40h353c22.1 0 40 17.9 40 40v461.3c0 22-17.9 39.9-40 39.9z"
        fill="#00B1FF"
        p-id="8010"
      ></path>
      <path
        d="M531.4 762.6h-26.2c-5.9 0-10.7-4.7-10.9-10.5l-1.9-57.2c-0.4-0.1-0.7-0.2-1.1-0.2-3.1 11.1-6.2 22.2-9.4 33.3-2.8 9.9-5.8 19.7-8.3 29.7-1 4-2.7 5.6-7 5.5-9.3-0.3-18.5-0.1-28.8-0.1 0.6-2.9 1-5.2 1.6-7.4 12.2-44.4 24.6-88.8 36.7-133.2 2.5-9.2 10.9-15.3 20.5-15.3h8.3c5.8-0.1 10.6 4.5 11 10.3l3.3 57.8c0.3 0.1 0.5 0.2 0.8 0.2 1.1-3.4 2.2-6.7 3.2-10.1 4.8-17.2 9.6-34.4 14.1-51.7 1.2-4.8 3.1-7 8.4-6.7 4.5 0.2 9.1 0.2 13.8 0.2 7.2 0 12.5 6.8 10.6 13.8-2.6 9.6-5.1 18.8-7.8 28-0.4 1.4-2.7 2.6-4.4 3.3-13.1 5.3-21.9 14.6-25.8 28.2-4.8 16.9-9.4 33.9-13.5 51-2.9 11.9-1 22.5 11.3 28.7 0.5 0.1 0.6 1 1.5 2.4zM608.6 758.4l11.8-82.5c0.8-5.4 5.4-9.4 10.8-9.4h2.1c6.7 0 11.8 6 10.8 12.6l-6.2 38.6c0.3 0.1 0.7 0.2 1 0.3 5.6-14.3 11.6-28.5 16.7-42.9 2.5-6.9 5.7-10.6 13.6-9.3 4.3 0.7 8.7 0.1 13.6 0.1-2.9 17.5-5.6 34.4-8.4 51.2 0.2 0.1 0.5 0.1 0.7 0.2 5.7-14.3 11.8-28.4 16.9-43 2.5-7 6.1-9.6 13.3-8.6 4.5 0.6 9.2 0.1 14.8 0.1-0.9 2.7-1.4 4.7-2.1 6.6-10.6 26.7-21.4 53.5-31.9 80.2-1.5 3.9-3.4 5.8-7.9 5.5-4.2-0.2-8.4-0.2-12.7-0.2-6.7 0-11.8-5.9-10.9-12.4l4.1-28.1c-0.5-0.2-1-0.3-1.5-0.5-3 7.1-6.9 14-8.7 21.4-4 16.6-13.5 23.2-30.2 19.8-2.8-0.2-5.8 0.3-9.7 0.3z"
        fill="#FFFFFF"
        p-id="8011"
      ></path>
      <path
        d="M608.9 702.3c-0.9 5.2-5.5 9.1-10.8 9.1-8.8 0-17.2 0.1-25.5-0.1-4.5-0.1-6.6 1.2-7.5 5.7-1.4 7.2-3.7 14.2-5 21.4-0.4 2 1.1 4.3 1.8 6.4 2.4-1.2 6.1-1.8 7-3.7 1.5-3.2 2.7-6.6 3.8-10.1 2.3-7.5 9.4-12.4 17.2-12.4h0.3c7.5 0 12.8 7.4 10.3 14.4-3.9 11-10.9 19.6-19.7 24.8-23.6 14-52.3-8.5-46-35.3 3.7-15.8 8-31.5 13.9-46.6 7-17.8 35.4-25.3 52.7-16.7 7.7 3.9 12.3 10 11.3 18.7-1 8.3-2.4 16.3-3.8 24.4z m-37.6-8.1c7.1 2.2 10.7 0.6 11.1-6.4 0.1-2.4 1.4-4.8 1.3-7.1 0-2.1-1.1-4.2-1.8-6.3-2.1 1.5-5.3 2.6-6.2 4.6-1.9 4.6-2.9 9.7-4.4 15.2z"
        fill="#FFFFFF"
        p-id="8012"
      ></path>
      <path
        d="M698.8 414.4H463.6c-11.8 0-21.4-9.6-21.4-21.4s9.6-21.4 21.4-21.4h235.2c11.8 0 21.4 9.6 21.4 21.4s-9.6 21.4-21.4 21.4z"
        fill="#0091F1"
        p-id="8013"
      ></path>
      <path
        d="M645.3 521.3H463.6c-11.8 0-21.4-9.6-21.4-21.4 0-11.8 9.6-21.4 21.4-21.4h181.8c11.8 0 21.4 9.6 21.4 21.4-0.1 11.8-9.7 21.4-21.5 21.4z"
        fill="#0091F1"
        p-id="8014"
      ></path>
    </svg>
    <div class="empty-txt">
      <slot>暂无内容</slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wgStuEmpty',
}
</script>
<style scoped lang="scss">
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;
  .empty-txt {
    color: #999;
  }
}
</style>
